import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Sparkles, DollarSign, Heart, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const BottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();

  if (!user) return null;

  const navItems = [
    { path: '/', label: 'Accueil', icon: Home },
    { path: '/pour-vous', label: 'Pour vous', icon: Sparkles },
    { path: '/adhesion', label: 'Adhésion', icon: DollarSign },
    { path: '/favoris', label: 'Favoris', icon: Heart },
    { path: '/profile', label: 'Profil', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50">
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon className="w-5 h-5 mb-1" />
              <span className="text-xs">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
